import styled from 'styled-components';

const SubCategoryHeaderBar = styled.div`
  display: flex;
`;

export { SubCategoryHeaderBar };
